import React from "react";
import FactureFromDevisBase from "./_shared/FactureFromDevisBase";
export default function FacturePartielle() {
    return <FactureFromDevisBase type="partielle" />;
}
